import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

import { orange } from '../../constants/colorConstants'
import Receipt from '../../images/receipt'

const useStyles = makeStyles((theme) => ({
  file: {
    whiteSpace: 'nowrap',
    color: orange,
    '& :link': {
      color: orange,
    },
    '& :visited': {
      color: orange,
    },
  },
  thumbnail: {
    width: '16px',
    height: '16px',
    display: 'inline-block',
    margin: 'auto',
    verticalAlign: 'middle',
  },
  text: {
    verticalAlign: 'text-top',
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto500Normal,
  },
}))

export const FileField = ({
  source,
  record,
  basePath,
  handleClick,
  ...props
}) => {
  const classes = useStyles()
  const translate = useTranslate()
  const fileContent = record[source]
  return Array.isArray(fileContent) ? (
    <div>
      {fileContent.map(
        (file) =>
          file.url && (
            <Typography
              key={file.url}
              variant="body2"
              className={classes.file}
              {...props}
            >
              <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
              >
                <Receipt className={classes.thumbnail} />
                &nbsp;
                <span className={classes.text}>
                  {translate('resources.payments.messages.downloadReceipt')}
                </span>
              </a>
            </Typography>
          )
      )}
    </div>
  ) : null
}
